import { RoutePermittedRole } from "shared/constants/AppConst";
import Banners from "./banners";
import BannerIndex from "./banners/BannerCreate";
import BannerUpdatIndex from './banners/BannerUpdate';
import { isModuleAuthorized } from "@crema/utility/Utils";
import Error403 from "pages/errorPages/Error403";

export const bannerConfig = [
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageBanner",
    exact: true,
    element: isModuleAuthorized("Manage Banners") ? <Banners /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageBanner/banners",
    exact: true,
    element: isModuleAuthorized("Manage Banners") ? <Banners /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageBanner/bannerCreate",
    exact: true,
    element: isModuleAuthorized("Add Banner") ? <BannerIndex /> : <Error403 />,
  },
  {
    permittedRole: RoutePermittedRole.User,
    path: "/master/manageBanner/bannerUpdate/:id",
    exact: true,
    element: isModuleAuthorized("Edit Banner") ? <BannerUpdatIndex /> : <Error403 />,
  }
];
